// extracted by mini-css-extract-plugin
module.exports = {"root":"PostCard-module--root--1RfJA","featured":"PostCard-module--featured--RAP38","arrow":"PostCard-module--arrow--35_jh"};